export function getWorkerDisplayName(worker = {}) {
  return (
    worker.displayName ||
    worker.fullName ||
    [worker.firstName, worker.lastName]
      .filter(Boolean)
      .join(" ")
      .trim() ||
    worker.name ||
    worker.email ||
    worker.uid ||
    "Worker"
  );
}

export function getWorkerPrimaryRole(worker = {}) {
  return (
    worker.primaryRole ||
    worker.position ||
    worker.workerType ||
    worker.roleType ||
    worker.role ||
    worker.platformRole ||
    "Worker"
  );
}

export function getWorkerFacility(worker = {}) {
  return (
    worker.facilityName ||
    worker.facilityId ||
    "No Facility"
  );
}

export function getWorkerEmail(worker = {}) {
  return worker.email || worker.uid || "";
}